import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/spaces/$spaceId/planned-meals/")({
  loader: async ({ context: { zero }, params: { spaceId } }) => {
    if (!zero) return;
    PlannedMealCalendar.preload(zero, {
      scopeId: spaceId,
      focusedDate: Temporal.Now.plainDateISO(),
      timeZone: Temporal.Now.timeZoneId(),
    });
  },
  component: () => {
    const { spaceId } = Route.useParams();
    return (
      <Navigate
        to="/spaces/$spaceId/planned-meals/$date"
        params={{ spaceId, date: Temporal.Now.plainDateISO() }}
        replace
      />
    );
  },
});
